import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type UsedAssignablesQueryVariables = GraphQLTypes.Exact<{
  networkIds?: GraphQLTypes.InputMaybe<Array<GraphQLTypes.Scalars['String']['input']> | GraphQLTypes.Scalars['String']['input']>;
  targetTypes: Array<GraphQLTypes.AssignmentTargetTypeEnum> | GraphQLTypes.AssignmentTargetTypeEnum;
  assignmentNames: Array<GraphQLTypes.AssignmentTypeValue> | GraphQLTypes.AssignmentTypeValue;
  assignableIds?: GraphQLTypes.InputMaybe<
    Array<GraphQLTypes.Scalars['String']['input']> | GraphQLTypes.Scalars['String']['input']
  >;
  textContains?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type UsedAssignablesQueryResult = { __typename?: 'Query' } & {
  networksUsedAssignables?: GraphQLTypes.Maybe<
    Array<
      | ({ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'> & {
            label?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
            >;
          })
      | ({ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'> & {
            label?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
            >;
          })
      | ({ __typename?: 'NetworksLegacyOrgLoc' } & Pick<GraphQLTypes.NetworksLegacyOrgLoc, 'id'> & {
            label?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
            >;
          })
      | ({ __typename?: 'NetworksOrgLoc' } & Pick<GraphQLTypes.NetworksOrgLoc, 'id'> & {
            label?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
            >;
          })
      | ({ __typename?: 'NetworksTerminal' } & Pick<GraphQLTypes.NetworksTerminal, 'unlocode' | 'id'> & {
            label?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
            >;
          })
    >
  >;
};

export const UsedAssignablesDocument = gql`
  query usedAssignables(
    $networkIds: [String!]
    $targetTypes: [AssignmentTargetTypeEnum!]!
    $assignmentNames: [AssignmentTypeValue!]!
    $assignableIds: [String!]
    $textContains: String
  ) {
    networksUsedAssignables(
      targetTypes: $targetTypes
      assignmentNames: $assignmentNames
      networkIds: $networkIds
      assignableIds: $assignableIds
      textContains: $textContains
    ) {
      id
      label {
        long
        short
      }
      ... on NetworksTerminal {
        unlocode
      }
    }
  }
`;
